export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14994.6e1b3234.jpg";